export const isNativeApp = typeof window !== 'undefined' && 
  typeof window.Capacitor !== 'undefined' && 
  window.Capacitor.isNativePlatform();